function asRecord(value) {
    return value;
}
function num(value) {
    return typeof value === 'number' && Number.isFinite(value) ? value : null;
}
export async function readPeerLinkCounters(peer, side) {
    const stats = await peer.getStats();
    let videoBytes = 0;
    let audioBytes = 0;
    let videoFrames = 0;
    let packetsLost = 0;
    let packetsReceived = 0;
    let rttMs = null;
    for (const report of stats.values()) {
        const row = asRecord(report);
        const type = row.type;
        const kind = row.kind;
        if (side === 'inbound' && type === 'inbound-rtp') {
            const bytes = num(row.bytesReceived) ?? 0;
            const lost = num(row.packetsLost) ?? 0;
            const received = num(row.packetsReceived) ?? 0;
            packetsLost += lost;
            packetsReceived += received;
            if (kind === 'video') {
                videoBytes += bytes;
                videoFrames += num(row.framesDecoded) ?? num(row.framesReceived) ?? 0;
            }
            else if (kind === 'audio') {
                audioBytes += bytes;
            }
        }
        if (side === 'outbound' && type === 'outbound-rtp') {
            const bytes = num(row.bytesSent) ?? 0;
            const sent = num(row.packetsSent) ?? 0;
            packetsReceived += sent;
            if (kind === 'video') {
                videoBytes += bytes;
                videoFrames += num(row.framesEncoded) ?? num(row.framesSent) ?? 0;
            }
            else if (kind === 'audio') {
                audioBytes += bytes;
            }
        }
        if (type === 'remote-inbound-rtp') {
            const rtt = num(row.roundTripTime);
            if (rtt !== null) {
                rttMs = Math.round(rtt * 1000);
            }
            packetsLost += num(row.packetsLost) ?? 0;
        }
        if (type === 'candidate-pair' && row.nominated === true) {
            const pairRtt = num(row.currentRoundTripTime);
            if (pairRtt !== null && rttMs === null) {
                rttMs = Math.round(pairRtt * 1000);
            }
        }
    }
    return { videoBytes, audioBytes, videoFrames, packetsLost, packetsReceived, rttMs };
}
export function deriveLinkRates(prev, next, elapsedMs) {
    if (!prev || elapsedMs < 400) {
        return { videoBitrateKbps: null, audioBitrateKbps: null, videoFps: null, packetLossPct: null };
    }
    const seconds = elapsedMs / 1000;
    const videoBitrateKbps = Math.max(0, ((next.videoBytes - prev.videoBytes) * 8) / seconds / 1000);
    const audioBitrateKbps = Math.max(0, ((next.audioBytes - prev.audioBytes) * 8) / seconds / 1000);
    const videoFps = Math.max(0, (next.videoFrames - prev.videoFrames) / seconds);
    const lostDelta = Math.max(0, next.packetsLost - prev.packetsLost);
    const receivedDelta = Math.max(0, next.packetsReceived - prev.packetsReceived);
    const total = lostDelta + receivedDelta;
    const packetLossPct = total > 0 ? (lostDelta / total) * 100 : 0;
    return {
        videoBitrateKbps,
        audioBitrateKbps,
        videoFps,
        packetLossPct,
    };
}
//# sourceMappingURL=stats.js.map